

/**
 * Mostra e nasconde il loader fullScreen
 * 
 * @param string state accetta 'show' e 'hide'
 * @returns {undefined}
 */
function themeSpinner( state ){
    themeSpinnerPassingJQuery( $, state, null );
}

function themeSpinnerPassingJQuery( $, state, callback ){

    var spinnerTemplate = '<div class="theme-loading fade"><div class="theme-spinner"></div></div>';

    if(state == 'show'){
        $( "body" ).prepend( spinnerTemplate );

        setTimeout(function(){
            $('.theme-loading').addClass('in');
            if(typeof(callback) == 'function'){ 
                setTimeout(callback, 100);
            }
        }, 50);
    }
    
    if(state == 'hide'){
        $('.theme-loading').removeClass('in');
        
        setTimeout(function(){
            $('.theme-loading').remove() 
            if(typeof(callback) == 'function'){
                setTimeout(callback, 100);
            }
        }, 150);
    }

}


function scrollToForm(){ 
    jQuery('html, body').animate({
        scrollTop: jQuery( '#register_form' ).offset().top - 100
    }, 1000);
}

function controlloFileImmagine(file)
{
    var fileType = file["type"];
    var ValidImageTypes = ["image/gif", "image/jpeg", "image/png"];
//        var maxDimension=5242880;//5 MB
    var maxDimension= 8*1024*1024;//8 MB
    if ($.inArray(fileType, ValidImageTypes) < 0) {
        return false;
    }
    if(file["size"]>maxDimension)
        return false;
    return true;
}

function reloadScrollingToTitle(){
    var etop = jQuery('.page-title').first().offset().top - 100;
    jQuery(window).scrollTop(etop);
    location.reload();
}